import {IRouteProps} from "../../../../ts/manager/view/ViewInterface";
import {PostDataChoice} from "../../../../ts/data/subject/PostDataFactory";
import RouteChoice from "../../../../ts/model-factory/basic/route/RouteChoice";
import RouteChoiceButton from "../../../element/button/RouteChoiceButton";
import {getManager} from "../../../../ts/manager/Manager";
import ImageVOView from "../../../partial/snippet/ImageVOView";
import {wbsp} from "../../../../ts/common/Constants";
import {getModelFactory} from "../../../../ts/model-factory/ModelFactory";
import AppButton from "../../../element/button/AppButton";
import moment from "moment";
import {formatPhoneNumber, isHTML, phpToMomentDateFormat} from "../../../../ts/common/SiteHelper";
import LocationAndMapView from "./LocationAndMapView";
import {JSX} from "react/jsx-runtime";
import GalleryThumbnailView from "../../../partial/snippet/GalleryThumbnailView";
import GalleryVideoView from "../../../partial/snippet/GalleryVideoView";
import CardDeckDownloadView from "../../../partial/snippet/CardDeckDownloadView";
import DeclareYourInterestForm from "./DeclareYourInterestForm";
import AccountLoginRegisterView from "../account/partial/AccountLoginRegisterView";
import React from "react";

interface IProps
{
    routeProps:IRouteProps;
    postChoice:PostDataChoice;
    editChoice?:RouteChoice|null;
    applicationsChoice?:RouteChoice|null;
    organisationChoice?:PostDataChoice|null;
    organisationRouteChoice?:RouteChoice|null;
}

const PostContentView = (props:IProps) =>
{
    const postChoice = props.postChoice;
    const editChoice = props.editChoice ?? null;
    const applicationsChoice = props.applicationsChoice ?? null;
    const organisationChoice = props.organisationChoice ?? null;
    const organisationRouteChoice = props.organisationRouteChoice ?? null;
    if(!postChoice.postType){
        return <></>
    }
    const canDeclareInterest = (postChoice.postType === 'project') || (postChoice.postType === 'career') || (postChoice.postType === 'offer')
    const postConfig = getManager().post.config[postChoice.postType];
    let nextIsGrey = false;
    const pageListHref = getModelFactory().browseRoute.getDefaultModel().choices[postChoice.postType]?.getHref() ?? null;
    return <>


        {(!!editChoice || (postChoice.postStatus !== "publish")) && <>
            <section className="content-block py-0">
                <div className="container">
                    <div className="row">
                        <div className="col-12">
                            {!!applicationsChoice && <>
                                <RouteChoiceButton
                                    routeChoice={applicationsChoice}
                                    label={"Applications"}
                                    className="btn edit-btn reduced me-1"
                                />
                            </>}
                            {!!editChoice && <>
                                <RouteChoiceButton
                                    routeChoice={editChoice}
                                    label={"Edit " + postConfig.name}
                                    className="btn edit-btn reduced me-4"
                                />
                            </>}
                            {(postChoice.postStatus !== "publish") && <>
                                <span className={((!!applicationsChoice || !!editChoice) ? "mt-auto" : "mt-3 d-block")+" mb-0 post-status-"+postChoice!.postStatus}>{getManager().post.postStatusNames[postChoice!.postStatus]}</span>
                            </>}
                        </div>
                    </div>
                </div>
            </section>
        </>}

        <section className="content-block set-bg-white">
            <div className="container">
                <div className="row d-flex align-items start g-4">

                    {!!postChoice.thumbnail && <>
                        <div className="col-12 col-md-3">
                            <ImageVOView
                                imageVO={postChoice.thumbnail}
                                size={"full"}
                            />
                        </div>
                    </>}


                    <div className="col-12 col-md-9">
                        <h2 className="block-title">About the {postConfig.name}</h2>
                        {!!postChoice.description && <>
                            <div
                                className="wysiwyg-content"
                                dangerouslySetInnerHTML={{__html: isHTML(postChoice.description) ? postChoice.description : "<p>"+postChoice.description+"</p>"}}>
                            </div>
                        </>}
                        {!!postChoice.mainContent && <>
                            <div
                                className="wysiwyg-content mt-4"
                                dangerouslySetInnerHTML={{__html: postChoice.mainContent}}>
                            </div>
                        </>}

                        <ul className="vertical-icons mt-4">

                            {!!organisationChoice && <>
                                <li className="who"><strong>Published by:</strong>{wbsp}{organisationChoice?.name ?? ""}</li>
                            </>}
                            {!!postChoice.addressVO.quickLocation() && <>
                                <li className="where"><strong>Location:</strong>{wbsp}{postChoice.addressVO.quickLocation()}</li>
                            </>}
                            {!!postChoice.categories.length && <>
                                <li className="what"><strong>Categories:</strong> {wbsp}

                                    {(() =>
                                    {
                                        const rendered: JSX.Element[] = [];
                                        let key = -1;
                                        for (let i = 0; i < postChoice.categories.length; i++)
                                        {
                                            key++;
                                            if (i !== 0)
                                            {
                                                rendered.push(<span key={key}>, </span>)
                                                key++;
                                            }
                                            rendered.push(
                                                pageListHref ?
                                                    <AppButton
                                                        key={key}
                                                        href={pageListHref+"?category="+postChoice.categories[i].id}
                                                    >
                                                        {postChoice.categories[i].name}
                                                    </AppButton> :
                                                    <span key={key}>
                                                    {postChoice.categories[i].name}
                                                </span>
                                            )
                                        }
                                        return rendered;
                                    })()}
                                </li>
                            </>}
                            {!!postChoice.endsAt && <>
                                <li className="when">
                                    <strong>Available until:</strong>
                                    {wbsp}{moment(postChoice.endsAt).format(phpToMomentDateFormat('jS F Y'))}
                                </li>
                            </>}

                        </ul>
                        {!!postChoice.websiteAddress && <>
                            <p>
                                <AppButton className="btn reduced mt-4" href={postChoice.websiteAddress} rel="noopener"
                                   target="_blank" title={" Visit Official Website for : " + postChoice.name}>Visit
                                    Project Website</AppButton>
                            </p>
                        </>}
                        {!!postChoice.socialChannelsVOs.length && <>
                            <ul className="horizontal-icons mt-2">

                                {postChoice.socialChannelsVOs.map((socialChannelsVO, index) =>

                                    <li key={index} className={"sc " + socialChannelsVO.id}>
                                        <AppButton href={socialChannelsVO.url} target="_blank" rel="noopener"
                                           title={postChoice.name + " on " + socialChannelsVO.title}>
                                        </AppButton>
                                    </li>
                                )}
                            </ul>
                        </>}
                    </div>
                </div>
            </div>
        </section>
        {!!postChoice.addressVO.getAddressDetails().length && <>
            <section className="content-block set-bg-grey p-0">
                <div className="container-fluid">
                    <LocationAndMapView
                        routeProps={props.routeProps}
                        postChoice={postChoice}
                        blockTitle="Where?"
                    />
                </div>
            </section>
        </>}
        {(!!organisationChoice || !!postChoice.keyContactVOs.length) && <>

            <section className={"content-block set-bg-"+(!nextIsGrey ? "white" : "grey")}>
                {nextIsGrey = !nextIsGrey}
                <div className="container">
                    {!!organisationChoice && <>
                        <div className="row d-flex align-items-center">
                            <div className="col">
                                <h2 className="block-title">Who With?</h2>
                            </div>
                        </div>
                    </>}
                    <div className="row d-flex align-items-start g-4">
                        {!!organisationChoice?.thumbnail && <>
                            <div className="col-12 col-md-3 owner-logo">
                            <ImageVOView
                                    imageVO={organisationChoice.thumbnail}
                                    size={"full"}
                                />
                            </div>
                        </>}
                        <div className="col-12 col-md-9">

                            {!!organisationChoice && <>
                                <h3>{organisationChoice.name}</h3>

                                <div
                                    className="wysiwyg-content"
                                    dangerouslySetInnerHTML={{__html: organisationChoice.description}}>
                                </div>

                                {!!organisationRouteChoice && <>
                                    <p>
                                        <RouteChoiceButton
                                            routeChoice={organisationRouteChoice}
                                            className="btn reduced mt-4"
                                            title={"More about: "+organisationChoice.name}
                                        >
                                            Read More
                                        </RouteChoiceButton>
                                    </p>
                                </>}
                            </>}

                            {!!postChoice.keyContactVOs.length && <>
                                <h4 className="mt-5">Key Contacts</h4>

                                <div className="row d-flex align-items-start">

                                    {postChoice.keyContactVOs.map((contact, index) =>

                                        <div className="col-6 col-md-4" key={index}>

                                            <ul className="vertical-icons no-icon mt-2">

                                                <li><strong>{contact.name}</strong></li>
                                                {!!contact.role && <li>
                                                    {contact.role}
                                                </li>}
                                                {!!contact.emailAddress && <li>
                                                    <AppButton href={"mailto:"+ contact.emailAddress}>{contact.emailAddress}</AppButton>
                                                </li>}
                                                {!!contact.telephoneNumber && <li>
                                                    <AppButton href={"tel:"+formatPhoneNumber(contact.telephoneNumber)}>{contact.telephoneNumber}</AppButton>
                                                </li>}

                                            </ul>

                                        </div>
                                    )}

                                </div>
                            </>}


                        </div>
                    </div>
                </div>
            </section>
        </>}
        {!!postChoice.imageVOs.length && <>

            <section className={"content-block set-bg-" + (!nextIsGrey ? "white" : "grey")}>
                {nextIsGrey = !nextIsGrey}
                <div className="container">

                    <div className="row">
                        <GalleryThumbnailView
                            imageVOs={postChoice.imageVOs}
                            size={"small_square"}
                        />
                    </div>

                </div>

            </section>
        </>}
        {!!postChoice.videoVOs.length && <>

            <section className={"content-block set-bg-" + (!nextIsGrey ? "white" : "grey")}>
                {nextIsGrey = !nextIsGrey}
                <div className="container">

                    <div className="row">
                        <GalleryVideoView
                            videoVOs={postChoice.videoVOs}
                        />
                    </div>

                </div>

            </section>
        </>}
        {!!postChoice.fileVOs.length && <>

            <section className={"content-block set-bg-" + (!nextIsGrey ? "white" : "grey")}>
                {nextIsGrey = !nextIsGrey}
                <div className="container">

                    <div className="row">
                        <div className="col"><h2 className="block-title">Downloads</h2></div>
                    </div>
                    <div className="row">
                        <CardDeckDownloadView
                            fileVOs={postChoice.fileVOs}
                        />
                    </div>

                </div>

            </section>
        </>}
        {canDeclareInterest && <>

            <section className={"content-block set-bg-" + (!nextIsGrey ? "white" : "grey")}>
                <div className="container">
                    <div className="row">
                        <div className="col-12 mb-4">
                            <h2 className="block-title">Register Interest</h2>
                        </div>
                    </div>

                    <div className="row">


                        {getManager().user.loggedIn() ? <>
                            <DeclareYourInterestForm
                                routeProps={props.routeProps}
                                postType={postChoice.postType}
                                postID={postChoice.postID}
                            />
                        </> : <>

                            <div className="row">
                                <div className="col">
                                    <h3 className="block-title">You must be logged in to declare your interest</h3>
                                </div>
                            </div>
                            <div className="row">
                                <div className="col">
                                    <AccountLoginRegisterView
                                        key={props.routeProps.mainViewKey} {...props.routeProps}
                                    />
                                </div>
                            </div>
                        </>}
                    </div>
                </div>

            </section>
        </>}
    </>
}
export default PostContentView;